import { toNumber } from 'lodash';

import isValueEmpty from '../../isValueEmpty';

export const errorMessage = __(
  'The maximum decimals allowed is %{maximumNumberOfDecimals}',
);

export const validateMaximumNumberOfDecimals = (
  value,
  maximumNumberOfDecimals,
) => {
  let error;

  if (isValueEmpty(value)) {
    return error;
  }

  const initialValue = String(toNumber(value));
  const cropedValue = String(toNumber(value).toFixed(maximumNumberOfDecimals));

  if (initialValue.length > cropedValue.length) {
    error = errorMessage.i__({
      maximumNumberOfDecimals,
    });
  }

  return error;
};
